export default "__VITE_PUBLIC_ASSET__756ca932__"